const XSS_PREFIX = 'for(;;);';

export default function json() {
    return this.text().then((text) => {
        if (text.startsWith(XSS_PREFIX)) {
            text = text.substring(XSS_PREFIX.length);
        }

        return JSON.parse(text);
    });
}
